import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import jwtDecode from 'jwt-decode';
import { toast } from 'react-hot-toast';

import { USER_TYPES } from 'src/constants/config';
import { isDemoUser } from 'src/utils/authUtils';

export const useDecodedToken = () => {
  const token = useSelector((state) => state.jwtToken.token);

  const decodedToken = useMemo(() => {
    if (!token) {
      return null;
    }

    try {
      const decoded = jwtDecode(token);
      return decoded;
    } catch (error) {
      toast.error('Error decoding token:', error);
      return null;
    }
  }, [token]);

  const isExpert = useMemo(() => {
    return decodedToken?.userType === USER_TYPES.EXPERT;
  }, [decodedToken]);

  const isDemo = useMemo(() => isDemoUser(decodedToken), [decodedToken]);

  return {
    decodedToken,
    isExpert,
    isDemo,
  };
};
